import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { SchedaCarico } from './SchedaCarico';

const INTESTAZIONI: Record<string, string> = {
  NumeroDdt: 'N. bolla',
  DataDdt: 'Del',
  DataRicevimento: 'Ricevuta il',
  RicevutoDa: 'Da chi',
  QuantitaAccettata: 'Accettata',
  QuantitaRifiutata: 'Respinta',
  ConNonConformita: 'Con respinte',
};

export function ElencoCarichi() {
  const [aperta, setAperta] = useState<string | null>(null);
  const [versione, setVersione] = useState(0);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Bolle di consegna</h1>
            <p>
              Quello che è arrivato, dalla più recente. Le bolle si registrano dalla scheda
              dell’ordine, dove ci sono le righe ancora da ricevere. Qui si guardano, e si
              annullano quando sono state segnate per errore — le quantità tornano da
              ricevere sull’ordine.
            </p>
          </div>
        </header>

        <DataGrid
          nomeGriglia="carichi"
          versione={versione}
          colonneVisibili={[
            'Numero',
            'Sede',
            'Stato',
            'NumeroDdt',
            'Fornitore',
            'DataDdt',
            'DataRicevimento',
            'Ordini',
            'RicevutoDa',
            'Righe',
            'QuantitaAccettata',
            'QuantitaRifiutata',
            'ConNonConformita',
          ]}
          intestazioni={INTESTAZIONI}
          idSelezionato={aperta}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id === 'string') setAperta(id);
          }}
        />
      </div>

      {aperta && (
        <SchedaCarico
          caricoId={aperta}
          onChiudi={() => setAperta(null)}
          onCambiato={() => setVersione((v) => v + 1)}
        />
      )}
    </section>
  );
}
